var _defs, _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScaricaAppQr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Raggruppa_9312",
    "data-name": "Raggruppa 9312",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 111,
    height: 111,
    viewBox: "0 0 111 111",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1811",
    "data-name": "Rettangolo 1811",
    width: 111,
    height: 111,
    fill: "none"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1810",
    "data-name": "Rettangolo 1810",
    width: 111,
    height: 111,
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_9313",
    "data-name": "Raggruppa 9313"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_9312-2",
    "data-name": "Raggruppa 9312",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1163",
    "data-name": "Tracciato 1163",
    d: "M43.5,12h0A1.5,1.5,0,1,0,45,13.5,1.5,1.5,0,0,0,43.5,12",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1164",
    "data-name": "Tracciato 1164",
    d: "M96,12H79.5A1.5,1.5,0,0,0,78,13.5v18A1.5,1.5,0,0,0,79.5,33h18A1.5,1.5,0,0,0,99,31.5v-18A1.5,1.5,0,0,0,97.5,12Zm0,6V28.5A1.5,1.5,0,0,1,94.5,30h-12A1.5,1.5,0,0,1,81,28.5v-12A1.5,1.5,0,0,1,82.5,15h12A1.5,1.5,0,0,1,96,16.5Z",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1165",
    "data-name": "Tracciato 1165",
    d: "M40.5,15h0A1.5,1.5,0,1,0,42,16.5,1.5,1.5,0,0,0,40.5,15",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1166",
    "data-name": "Tracciato 1166",
    d: "M67.5,18h3A1.5,1.5,0,0,0,72,16.5,1.5,1.5,0,0,1,73.5,15a1.5,1.5,0,0,0,0-3h-9a1.5,1.5,0,0,0,0,3A1.5,1.5,0,0,1,66,16.5,1.5,1.5,0,0,0,67.5,18",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1167",
    "data-name": "Tracciato 1167",
    d: "M36,19.5h0A1.5,1.5,0,1,0,37.5,18,1.5,1.5,0,0,0,36,19.5",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1168",
    "data-name": "Tracciato 1168",
    d: "M45,19.5h0A1.5,1.5,0,1,0,46.5,18,1.5,1.5,0,0,0,45,19.5",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1169",
    "data-name": "Tracciato 1169",
    d: "M63,19.5h0A1.5,1.5,0,1,0,61.5,21,1.5,1.5,0,0,0,63,19.5",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1170",
    "data-name": "Tracciato 1170",
    d: "M87,18H85.5A1.5,1.5,0,0,0,84,19.5v6A1.5,1.5,0,0,0,85.5,27h6A1.5,1.5,0,0,0,93,25.5v-6A1.5,1.5,0,0,0,91.5,18Z",
    fill: "#d90010"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1171",
    "data-name": "Tracciato 1171",
    d: "M40.5,21h0A1.5,1.5,0,0,0,39,22.5v3a1.5,1.5,0,0,0,3,0v-3A1.5,1.5,0,0,0,40.5,21",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1172",
    "data-name": "Tracciato 1172",
    d: "M24,27h1.5A1.5,1.5,0,0,0,27,25.5v-6A1.5,1.5,0,0,0,25.5,18h-6A1.5,1.5,0,0,0,18,19.5v6A1.5,1.5,0,0,0,19.5,27Z",
    fill: "#d90010"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1173",
    "data-name": "Tracciato 1173",
    d: "M18,33H31.5A1.5,1.5,0,0,0,33,31.5v-18A1.5,1.5,0,0,0,31.5,12h-18A1.5,1.5,0,0,0,12,13.5v18A1.5,1.5,0,0,0,13.5,33Zm-3-6V16.5A1.5,1.5,0,0,1,16.5,15h12A1.5,1.5,0,0,1,30,16.5v12A1.5,1.5,0,0,1,28.5,30h-12A1.5,1.5,0,0,1,15,28.5Z",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1174",
    "data-name": "Tracciato 1174",
    d: "M73.5,33h0A1.5,1.5,0,0,0,75,31.5v-3A1.5,1.5,0,0,0,73.5,27a1.5,1.5,0,0,1,0-3,1.5,1.5,0,0,0,0-3h-6A1.5,1.5,0,0,0,66,22.5v3A1.5,1.5,0,0,0,67.5,27,1.5,1.5,0,0,1,69,28.5,1.5,1.5,0,0,0,70.5,30,1.5,1.5,0,0,1,72,31.5,1.5,1.5,0,0,0,73.5,33",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1175",
    "data-name": "Tracciato 1175",
    d: "M45,34.5h0A1.5,1.5,0,1,0,46.5,33,1.5,1.5,0,0,0,45,34.5",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1176",
    "data-name": "Tracciato 1176",
    d: "M58.5,36h0a1.5,1.5,0,0,0,0,3h6A1.5,1.5,0,0,0,66,37.5a1.5,1.5,0,0,1,3,0A1.5,1.5,0,0,0,70.5,39,1.5,1.5,0,0,1,72,40.5v6A1.5,1.5,0,0,1,70.5,48a1.5,1.5,0,0,0,0,3h3A1.5,1.5,0,0,1,75,52.5v3a1.5,1.5,0,0,0,3,0,1.5,1.5,0,0,1,3,0,1.5,1.5,0,0,0,3,0v-3A1.5,1.5,0,0,0,82.5,51,1.5,1.5,0,0,1,81,49.5v-12A1.5,1.5,0,0,0,79.5,36h-6A1.5,1.5,0,0,1,72,34.5,1.5,1.5,0,0,0,70.5,33,1.5,1.5,0,0,1,69,31.5a1.5,1.5,0,0,0-3,0,1.5,1.5,0,0,1-3,0,1.5,1.5,0,0,0-3,0v3A1.5,1.5,0,0,1,58.5,36M78,45v1.5a1.5,1.5,0,0,1-3,0v-3a1.5,1.5,0,0,1,3,0Z",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1177",
    "data-name": "Tracciato 1177",
    d: "M21,37.5h0A1.5,1.5,0,0,0,19.5,36h-6A1.5,1.5,0,0,0,12,37.5v6a1.5,1.5,0,0,0,3,0A1.5,1.5,0,0,1,16.5,42,1.5,1.5,0,0,0,18,40.5,1.5,1.5,0,0,1,19.5,39,1.5,1.5,0,0,0,21,37.5",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1178",
    "data-name": "Tracciato 1178",
    d: "M91.5,36h0A1.5,1.5,0,1,0,93,37.5,1.5,1.5,0,0,0,91.5,36",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1179",
    "data-name": "Tracciato 1179",
    d: "M31.5,39h6A1.5,1.5,0,0,0,39,37.5v-6a1.5,1.5,0,0,0-3,0v3A1.5,1.5,0,0,1,34.5,36h-9a1.5,1.5,0,0,0,0,3A1.5,1.5,0,0,1,27,40.5a1.5,1.5,0,0,0,3,0A1.5,1.5,0,0,1,31.5,39",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1180",
    "data-name": "Tracciato 1180",
    d: "M42,40.5h0A1.5,1.5,0,1,0,40.5,42,1.5,1.5,0,0,0,42,40.5",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1181",
    "data-name": "Tracciato 1181",
    d: "M87,40.5h0A1.5,1.5,0,1,0,88.5,39,1.5,1.5,0,0,0,87,40.5",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1182",
    "data-name": "Tracciato 1182",
    d: "M94.5,42h-3a1.5,1.5,0,0,0,0,3A1.5,1.5,0,0,1,93,46.5v3A1.5,1.5,0,0,0,94.5,51a1.5,1.5,0,0,1,0,3A1.5,1.5,0,0,0,93,55.5v6A1.5,1.5,0,0,0,94.5,63a1.5,1.5,0,0,1,0,3A1.5,1.5,0,0,0,93,67.5v3a1.5,1.5,0,0,0,3,0A1.5,1.5,0,0,1,97.5,69,1.5,1.5,0,0,0,99,67.5v-6A1.5,1.5,0,0,0,97.5,60a1.5,1.5,0,0,1,0-3A1.5,1.5,0,0,0,99,55.5v-6A1.5,1.5,0,0,0,97.5,48a1.5,1.5,0,0,1,0-3A1.5,1.5,0,0,0,99,43.5v-3a1.5,1.5,0,0,0-3,0A1.5,1.5,0,0,1,94.5,42",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1183",
    "data-name": "Tracciato 1183",
    d: "M31.5,42h0A1.5,1.5,0,1,0,33,43.5,1.5,1.5,0,0,0,31.5,42",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1184",
    "data-name": "Tracciato 1184",
    d: "M58.5,48h0A1.5,1.5,0,1,0,57,46.5,1.5,1.5,0,0,0,58.5,48",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1185",
    "data-name": "Tracciato 1185",
    d: "M66,43.5h0A1.5,1.5,0,0,0,64.5,42h-3a1.5,1.5,0,0,0,0,3A1.5,1.5,0,0,1,63,46.5v3a1.5,1.5,0,0,0,3,0A1.5,1.5,0,0,1,67.5,48a1.5,1.5,0,0,0,0-3A1.5,1.5,0,0,1,66,43.5",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1186",
    "data-name": "Tracciato 1186",
    d: "M84,46.5h0A1.5,1.5,0,1,0,85.5,45,1.5,1.5,0,0,0,84,46.5",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1187",
    "data-name": "Tracciato 1187",
    d: "M21,49.5h0A1.5,1.5,0,1,0,22.5,48,1.5,1.5,0,0,0,21,49.5",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1188",
    "data-name": "Tracciato 1188",
    d: "M55.5,51h0A1.5,1.5,0,1,0,54,49.5,1.5,1.5,0,0,0,55.5,51",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1189",
    "data-name": "Tracciato 1189",
    d: "M24,52.5h0A1.5,1.5,0,1,0,25.5,51,1.5,1.5,0,0,0,24,52.5",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1190",
    "data-name": "Tracciato 1190",
    d: "M60,54v1.5a1.5,1.5,0,0,0,3,0v-3a1.5,1.5,0,0,0-3,0Z",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1191",
    "data-name": "Tracciato 1191",
    d: "M52.5,57h0A1.5,1.5,0,1,0,51,55.5,1.5,1.5,0,0,0,52.5,57",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1192",
    "data-name": "Tracciato 1192",
    d: "M18,57V49.5A1.5,1.5,0,0,0,16.5,48h-3a1.5,1.5,0,0,0,0,3A1.5,1.5,0,0,1,15,52.5v6a1.5,1.5,0,0,0,3,0Z",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1193",
    "data-name": "Tracciato 1193",
    d: "M21,58.5v3A1.5,1.5,0,0,0,22.5,63,1.5,1.5,0,0,1,24,64.5a1.5,1.5,0,0,0,3,0v-6A1.5,1.5,0,0,0,25.5,57h-3A1.5,1.5,0,0,0,21,58.5",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1194",
    "data-name": "Tracciato 1194",
    d: "M46.5,57h0A1.5,1.5,0,1,0,48,58.5,1.5,1.5,0,0,0,46.5,57",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1195",
    "data-name": "Tracciato 1195",
    d: "M58.5,60h0A1.5,1.5,0,1,0,57,58.5,1.5,1.5,0,0,0,58.5,60",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1196",
    "data-name": "Tracciato 1196",
    d: "M76.5,60h0A1.5,1.5,0,0,0,75,61.5,1.5,1.5,0,0,1,73.5,63a1.5,1.5,0,0,0,0,3A1.5,1.5,0,0,1,75,67.5a1.5,1.5,0,0,0,3,0A1.5,1.5,0,0,1,79.5,66,1.5,1.5,0,0,0,81,64.5,1.5,1.5,0,0,1,82.5,63a1.5,1.5,0,0,0,0-3A1.5,1.5,0,0,1,81,58.5a1.5,1.5,0,0,0-3,0A1.5,1.5,0,0,1,76.5,60",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1197",
    "data-name": "Tracciato 1197",
    d: "M13.5,60h0A1.5,1.5,0,1,0,15,61.5,1.5,1.5,0,0,0,13.5,60",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1198",
    "data-name": "Tracciato 1198",
    d: "M45,61.5h0A1.5,1.5,0,1,0,43.5,63,1.5,1.5,0,0,0,45,61.5",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1199",
    "data-name": "Tracciato 1199",
    d: "M61.5,63h0a1.5,1.5,0,0,0,0,3h3A1.5,1.5,0,0,1,66,67.5a1.5,1.5,0,0,0,3,0v-3A1.5,1.5,0,0,0,67.5,63a1.5,1.5,0,0,1,0-3,1.5,1.5,0,0,0,0-3h-3A1.5,1.5,0,0,0,63,58.5v3A1.5,1.5,0,0,1,61.5,63",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1200",
    "data-name": "Tracciato 1200",
    d: "M90,61.5v-12a1.5,1.5,0,0,0-3,0v15A1.5,1.5,0,0,0,88.5,66h3a1.5,1.5,0,0,0,0-3A1.5,1.5,0,0,1,90,61.5",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1201",
    "data-name": "Tracciato 1201",
    d: "M12,67.5h0A1.5,1.5,0,1,0,13.5,66,1.5,1.5,0,0,0,12,67.5",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1202",
    "data-name": "Tracciato 1202",
    d: "M18,67.5h0A1.5,1.5,0,0,1,16.5,69a1.5,1.5,0,0,0,0,3h3A1.5,1.5,0,0,0,21,70.5,1.5,1.5,0,0,1,22.5,69a1.5,1.5,0,0,0,0-3h-3A1.5,1.5,0,0,0,18,67.5",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1203",
    "data-name": "Tracciato 1203",
    d: "M84,67.5h0A1.5,1.5,0,1,0,82.5,69,1.5,1.5,0,0,0,84,67.5",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1204",
    "data-name": "Tracciato 1204",
    d: "M28.5,69h0A1.5,1.5,0,0,0,27,70.5v3A1.5,1.5,0,0,0,28.5,75h3a1.5,1.5,0,0,0,0-3A1.5,1.5,0,0,1,30,70.5,1.5,1.5,0,0,0,28.5,69",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1205",
    "data-name": "Tracciato 1205",
    d: "M43.5,69h-6a1.5,1.5,0,0,1,0-3h3a1.5,1.5,0,0,0,0-3h-3a1.5,1.5,0,0,1,0-3h3A1.5,1.5,0,0,0,42,58.5v-3A1.5,1.5,0,0,0,40.5,54,1.5,1.5,0,0,1,39,52.5v-3a1.5,1.5,0,0,1,3,0v3A1.5,1.5,0,0,0,43.5,54h3A1.5,1.5,0,0,0,48,52.5v-3A1.5,1.5,0,0,0,46.5,48,1.5,1.5,0,1,1,48,46.5,1.5,1.5,0,0,0,49.5,48h3a1.5,1.5,0,0,0,0-3A1.5,1.5,0,0,1,51,43.5v-3A1.5,1.5,0,0,1,52.5,39,1.5,1.5,0,0,0,54,37.5,1.5,1.5,0,0,1,55.5,36,1.5,1.5,0,0,0,57,34.5v-3A1.5,1.5,0,0,1,58.5,30,1.5,1.5,0,0,0,60,28.5v-3A1.5,1.5,0,0,0,58.5,24,1.5,1.5,0,0,1,57,22.5v-3A1.5,1.5,0,0,1,58.5,18,1.5,1.5,0,0,0,60,16.5v-3a1.5,1.5,0,0,0-3,0A1.5,1.5,0,0,1,55.5,15h-3a1.5,1.5,0,0,0,0,3A1.5,1.5,0,0,1,54,19.5v3a1.5,1.5,0,0,1-3,0,1.5,1.5,0,0,0-3,0v3A1.5,1.5,0,0,1,46.5,27h-3A1.5,1.5,0,0,0,42,28.5v3a1.5,1.5,0,0,0,3,0,1.5,1.5,0,0,1,3,0,1.5,1.5,0,0,0,3,0A1.5,1.5,0,1,1,52.5,33,1.5,1.5,0,0,0,51,34.5,1.5,1.5,0,0,1,49.5,36,1.5,1.5,0,0,0,48,37.5,1.5,1.5,0,0,1,46.5,39,1.5,1.5,0,0,0,45,40.5,1.5,1.5,0,0,1,43.5,42,1.5,1.5,0,0,0,42,43.5,1.5,1.5,0,0,1,40.5,45h-3A1.5,1.5,0,0,0,36,46.5,1.5,1.5,0,0,1,34.5,48h-3A1.5,1.5,0,0,1,30,46.5,1.5,1.5,0,0,0,28.5,45,1.5,1.5,0,0,1,27,43.5,1.5,1.5,0,0,0,25.5,42h-6a1.5,1.5,0,0,0,0,3h3A1.5,1.5,0,0,1,24,46.5,1.5,1.5,0,0,0,25.5,48,1.5,1.5,0,0,1,27,49.5,1.5,1.5,0,0,0,28.5,51h3a1.5,1.5,0,0,1,0,3h-3a1.5,1.5,0,0,0,0,3h3a1.5,1.5,0,0,1,0,3,1.5,1.5,0,0,0,0,3,1.5,1.5,0,0,1,0,3,1.5,1.5,0,0,0,0,3A1.5,1.5,0,0,1,33,70.5,1.5,1.5,0,0,0,34.5,72h3A1.5,1.5,0,0,1,39,73.5,1.5,1.5,0,0,0,40.5,75,1.5,1.5,0,0,1,42,76.5,1.5,1.5,0,0,0,43.5,78h3A1.5,1.5,0,0,0,48,76.5v-3A1.5,1.5,0,0,0,46.5,72,1.5,1.5,0,0,1,45,70.5,1.5,1.5,0,0,0,43.5,69",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1206",
    "data-name": "Tracciato 1206",
    d: "M57,67.5h0a1.5,1.5,0,0,0-3,0A1.5,1.5,0,1,1,52.5,66a1.5,1.5,0,0,0,0-3A1.5,1.5,0,0,1,51,61.5a1.5,1.5,0,0,0-3,0A1.5,1.5,0,0,1,46.5,63,1.5,1.5,0,0,0,45,64.5v3A1.5,1.5,0,0,0,46.5,69,1.5,1.5,0,0,1,48,70.5,1.5,1.5,0,0,0,49.5,72h3A1.5,1.5,0,0,1,54,73.5v3a1.5,1.5,0,0,0,3,0v-3A1.5,1.5,0,0,1,58.5,72a1.5,1.5,0,0,0,0-3A1.5,1.5,0,0,1,57,67.5",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1207",
    "data-name": "Tracciato 1207",
    d: "M88.5,69h0A1.5,1.5,0,1,0,90,70.5,1.5,1.5,0,0,0,88.5,69",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1208",
    "data-name": "Tracciato 1208",
    d: "M13.5,75h0A1.5,1.5,0,1,0,12,73.5,1.5,1.5,0,0,0,13.5,75",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1209",
    "data-name": "Tracciato 1209",
    d: "M24,73.5h0A1.5,1.5,0,1,0,22.5,75,1.5,1.5,0,0,0,24,73.5",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1210",
    "data-name": "Tracciato 1210",
    d: "M66,72V70.5a1.5,1.5,0,0,0-3,0A1.5,1.5,0,0,1,61.5,72,1.5,1.5,0,0,0,60,73.5v3A1.5,1.5,0,0,0,61.5,78h3A1.5,1.5,0,0,0,66,76.5Z",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1211",
    "data-name": "Tracciato 1211",
    d: "M36,78v7.5a1.5,1.5,0,0,0,3,0v-9a1.5,1.5,0,0,0-3,0Z",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1212",
    "data-name": "Tracciato 1212",
    d: "M93,75H91.5a1.5,1.5,0,0,0,0,3A1.5,1.5,0,0,1,93,79.5,1.5,1.5,0,0,0,94.5,81a1.5,1.5,0,0,1,0,3A1.5,1.5,0,0,0,93,85.5,1.5,1.5,0,0,1,91.5,87a1.5,1.5,0,0,0,0,3h3A1.5,1.5,0,0,1,96,91.5a1.5,1.5,0,0,0,3,0v-15A1.5,1.5,0,0,0,97.5,75Z",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1213",
    "data-name": "Tracciato 1213",
    d: "M27,78H13.5A1.5,1.5,0,0,0,12,79.5v18A1.5,1.5,0,0,0,13.5,99h18A1.5,1.5,0,0,0,33,97.5v-18A1.5,1.5,0,0,0,31.5,78Zm3,6V94.5A1.5,1.5,0,0,1,28.5,96h-12A1.5,1.5,0,0,1,15,94.5v-12A1.5,1.5,0,0,1,16.5,81h12A1.5,1.5,0,0,1,30,82.5Z",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1214",
    "data-name": "Tracciato 1214",
    d: "M52.5,81h0A1.5,1.5,0,1,0,51,79.5,1.5,1.5,0,0,0,52.5,81",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1215",
    "data-name": "Tracciato 1215",
    d: "M79.5,81h0A1.5,1.5,0,1,0,78,79.5,1.5,1.5,0,0,0,79.5,81",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1216",
    "data-name": "Tracciato 1216",
    d: "M45,81H43.5a1.5,1.5,0,0,0,0,3h3a1.5,1.5,0,0,0,0-3Z",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1217",
    "data-name": "Tracciato 1217",
    d: "M21,84H19.5A1.5,1.5,0,0,0,18,85.5v6A1.5,1.5,0,0,0,19.5,93h6A1.5,1.5,0,0,0,27,91.5v-6A1.5,1.5,0,0,0,25.5,84Z",
    fill: "#d90010"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1218",
    "data-name": "Tracciato 1218",
    d: "M87,87V85.5A1.5,1.5,0,0,1,88.5,84,1.5,1.5,0,0,0,90,82.5v-3A1.5,1.5,0,0,0,88.5,78,1.5,1.5,0,0,1,87,76.5v-3A1.5,1.5,0,0,0,85.5,72h-12A1.5,1.5,0,0,0,72,73.5v3A1.5,1.5,0,0,1,70.5,78h-3A1.5,1.5,0,0,0,66,79.5,1.5,1.5,0,0,1,64.5,81h-6A1.5,1.5,0,0,0,57,82.5v3A1.5,1.5,0,0,0,58.5,87h3A1.5,1.5,0,0,1,63,88.5v9a1.5,1.5,0,0,0,3,0,1.5,1.5,0,0,1,3,0A1.5,1.5,0,0,0,70.5,99h3A1.5,1.5,0,0,0,75,97.5,1.5,1.5,0,0,1,76.5,96,1.5,1.5,0,0,0,78,94.5v-3A1.5,1.5,0,0,0,76.5,90h-3A1.5,1.5,0,0,0,72,91.5a1.5,1.5,0,0,1-3,0v-3A1.5,1.5,0,0,0,67.5,87a1.5,1.5,0,0,1,0-3A1.5,1.5,0,0,0,69,82.5a1.5,1.5,0,0,1,3,0v3A1.5,1.5,0,0,0,73.5,87h9a1.5,1.5,0,0,1,0,3,1.5,1.5,0,0,0,0,3,1.5,1.5,0,0,1,0,3h-3a1.5,1.5,0,0,0,0,3h9a1.5,1.5,0,0,0,0-3,1.5,1.5,0,0,1,0-3,1.5,1.5,0,0,0,0-3A1.5,1.5,0,0,1,87,88.5Zm-6-3H76.5A1.5,1.5,0,0,1,75,82.5v-6A1.5,1.5,0,0,1,76.5,75h6A1.5,1.5,0,0,1,84,76.5v6A1.5,1.5,0,0,1,82.5,84Z",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1219",
    "data-name": "Tracciato 1219",
    d: "M36,91.5v6a1.5,1.5,0,0,0,3,0v-3A1.5,1.5,0,0,1,40.5,93,1.5,1.5,0,0,0,42,91.5v-3a1.5,1.5,0,0,0-3,0A1.5,1.5,0,0,1,37.5,90,1.5,1.5,0,0,0,36,91.5",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1220",
    "data-name": "Tracciato 1220",
    d: "M45,94.5h0A1.5,1.5,0,1,0,43.5,96,1.5,1.5,0,0,0,45,94.5",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1221",
    "data-name": "Tracciato 1221",
    d: "M49.5,96h3A1.5,1.5,0,0,1,54,97.5a1.5,1.5,0,0,0,3,0v-6a1.5,1.5,0,0,0-3,0A1.5,1.5,0,1,1,52.5,90a1.5,1.5,0,0,0,0-3A1.5,1.5,0,0,1,51,85.5a1.5,1.5,0,0,0-3,0A1.5,1.5,0,0,1,46.5,87,1.5,1.5,0,0,0,45,88.5v3A1.5,1.5,0,0,0,46.5,93,1.5,1.5,0,0,1,48,94.5,1.5,1.5,0,0,0,49.5,96",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1222",
    "data-name": "Tracciato 1222",
    d: "M93,96v1.5A1.5,1.5,0,0,0,94.5,99h3a1.5,1.5,0,0,0,0-3A1.5,1.5,0,0,1,96,94.5a1.5,1.5,0,0,0-3,0Z",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1223",
    "data-name": "Tracciato 1223",
    d: "M46.5,99h0A1.5,1.5,0,1,0,45,97.5,1.5,1.5,0,0,0,46.5,99",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1224",
    "data-name": "Tracciato 1224",
    d: "M48.015,48.008l14.97.015v14.97l-14.97-.015Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1225",
    "data-name": "Tracciato 1225",
    d: "M57.352,61.267H61.2V49.733H49.663V61.267h7.689Z",
    fill: "#d90010"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1226",
    "data-name": "Tracciato 1226",
    d: "M59.013,59.056a4.519,4.519,0,0,1-7.253-3.569,4.532,4.532,0,0,1,7.253-3.556.194.194,0,0,1,.05.256L58.271,53.4a.19.19,0,0,1-.268.052,2.8,2.8,0,0,0-1.727-.627,2.646,2.646,0,0,0-2.547,2.66,2.618,2.618,0,0,0,2.547,2.686,2.667,2.667,0,0,0,1.738-.614.188.188,0,0,1,.257.064l.805,1.177a.2.2,0,0,1-.063.256",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScaricaAppQr);
export default __webpack_public_path__ + "static/media/scarica-app-qr.aa5ece51accbfcc920a345ee6b51daaf.svg";
export { ForwardRef as ReactComponent };